import { render, staticRenderFns } from "./MergerAcquisitionsListView.vue?vue&type=template&id=be6dd3a0&scoped=true&"
import script from "./MergerAcquisitionsListView.vue?vue&type=script&lang=ts&"
export * from "./MergerAcquisitionsListView.vue?vue&type=script&lang=ts&"
import style0 from "./MergerAcquisitionsListView.vue?vue&type=style&index=0&id=be6dd3a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be6dd3a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be6dd3a0')) {
      api.createRecord('be6dd3a0', component.options)
    } else {
      api.reload('be6dd3a0', component.options)
    }
    module.hot.accept("./MergerAcquisitionsListView.vue?vue&type=template&id=be6dd3a0&scoped=true&", function () {
      api.rerender('be6dd3a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/mergerAcquisitions/MergerAcquisitionsListView.vue"
export default component.exports